import React, { FunctionComponent, useState, useCallback, useEffect, Fragment } from "react";
import { Card, DatePicker, Button, Space, Spin, Tag, Collapse, } from "antd";
import { StoreType } from "../../redux/store";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment, { Moment } from "moment";
import fetchAdsNoStateMachine, {
  FetchAdsNoStateMachine,
} from "../../redux/actions/reports/fetchAdsNoStateMachine";
import fetchUnfulfilledAdsOver20Hours, {
  FetchUnfulfilledAdsOver20Hours
} from "../../redux/actions/reports/fetchUnfulfilledAdsOver20Hours";
import fetchDirectoryNoStateMachine, {
  FetchDirectoryNoStateMachine
} from "../../redux/actions/reports/fetchDirectoryNoStateMachine"
import fetchUnfulfilledDirectoryOver20Hours, {
  FetchUnfulfilledDirectoryOver20Hours
} from "../../redux/actions/reports/fetchUnfulfilledDirectoryOver20Hours";
import fetchCatchAll, {
  FetchCatchAll
} from "../../redux/actions/reports/fetchCatchAll";
import fetchAdsWithPdfConversionFailure, {
  FetchAdsWithPdfConversionFailure
} from "../../redux/actions/reports/fetchAdsWithPdfConversionFailure";
import fetchAdsWithoutPdfs, {
  FetchAdsWithoutPdfs
} from "../../redux/actions/reports/fetchAdsWithoutPdfs"
import {
  AdsWithoutStateMachineRecord,
  UnfulfilledAdsOver20HoursRecord,
  DirectoryNoStateMachineTableRecord,
  UnfulfilledDirectoryOver20HoursRecord,
  CatchAllTableRecord,
  AdsWithPdfNoConversionRecord,
  AdsWithoutPdfsRecord,
} from "../../redux/types/reportTypes";
import OrigamiAdsNoSMTable from "./AdsNoStateMachineTable";
import UnfulfilledAdsOver20HoursTable  from "./UnfulfilledAdsOver20HoursTable";
import DirectoryNoStateMachineTable from "./DirectoryNoStateMachineTable"
import UnfulfilledDirectoryOver20HoursTable from "./UnfulfilledDirectoryOver20HoursTable"
import CatchAllTable from "./CatchAllTable"
import AdsWithPdfConversionFailureTable from "./AdsWithPdfConversionFailureTable"
import AdsWithoutPdfs from "./AdsWithoutPdfs"

type AdsPastSlaProps = {
  fetchAdsNoStateMachine: FetchAdsNoStateMachine;
  fetchUnfulfilledAdsOver20Hours: FetchUnfulfilledAdsOver20Hours;
  fetchDirectoryNoStateMachine: FetchDirectoryNoStateMachine;
  fetchUnfulfilledDirectoryOver20Hours: FetchUnfulfilledDirectoryOver20Hours;
  fetchCatchAll: FetchCatchAll;
  fetchAdsWithPdfConversionFailure: FetchAdsWithPdfConversionFailure;
  fetchAdsWithoutPdfs: FetchAdsWithoutPdfs;
  origamiAdsNoSmRecords: Array<AdsWithoutStateMachineRecord>;
  unfulfilledAdsOver20HoursRecords: Array<UnfulfilledAdsOver20HoursRecord>
  directoryNoStateMachineRecords: Array<DirectoryNoStateMachineTableRecord>;
  unfulfilledDirectoryOver20HoursRecords: Array<UnfulfilledDirectoryOver20HoursRecord>;
  catchAllRecords: Array<CatchAllTableRecord>;
  adsWithPdfNoConversionRecords: Array<AdsWithPdfNoConversionRecord>;
  adsWithoutPdfsRecords: Array<AdsWithoutPdfsRecord>;
  unfulfilledDirectoryOver20HoursLoading: boolean;
  unfulfilledAdsOver20HoursLoading: boolean;
  directoryNoStateMachineLoading: boolean;
  adsWithPdfNoConversionLoading: boolean;
  origamiAdsNoSmLoading: boolean;
  adsWithoutPdfsLoading: boolean;
  catchAllLoading: boolean;
};

const initialFilters = () => {
  const endDate = moment();
  const startDate = moment().add(-1, "month");
  return { startDate, endDate };
};

export const AdsPastSla: FunctionComponent<AdsPastSlaProps> = ({
  fetchAdsNoStateMachine,
  fetchUnfulfilledAdsOver20Hours,
  fetchDirectoryNoStateMachine,
  fetchUnfulfilledDirectoryOver20Hours,
  fetchAdsWithPdfConversionFailure,
  fetchCatchAll,
  fetchAdsWithoutPdfs,
  origamiAdsNoSmLoading,
  origamiAdsNoSmRecords,
  unfulfilledAdsOver20HoursLoading,
  unfulfilledAdsOver20HoursRecords,
  directoryNoStateMachineLoading,
  directoryNoStateMachineRecords,
  unfulfilledDirectoryOver20HoursLoading,
  unfulfilledDirectoryOver20HoursRecords,
  catchAllRecords,
  catchAllLoading,
  adsWithPdfNoConversionRecords,
  adsWithPdfNoConversionLoading,
  adsWithoutPdfsLoading,
  adsWithoutPdfsRecords,
}: AdsPastSlaProps) => {
  const [startDate, setStartDate] = useState<Moment>(moment());
  const [endDate, setEndDate] = useState<Moment>(moment());

  const onCalendarChange = (dates: any) => {
    const [startDate, endDate] = dates as [Moment, Moment];
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const setInitialState = useCallback(() => {
    const initial = initialFilters();
    fetchAdsNoStateMachine(initial);
    fetchUnfulfilledAdsOver20Hours(initial);
    fetchDirectoryNoStateMachine(initial);
    fetchUnfulfilledDirectoryOver20Hours(initial);
    fetchAdsWithPdfConversionFailure(initial);
    fetchCatchAll(initial);
    fetchAdsWithoutPdfs(initial);
    setStartDate(initial.startDate);
    setEndDate(initial.endDate);
  }, [fetchAdsNoStateMachine, fetchUnfulfilledAdsOver20Hours, fetchDirectoryNoStateMachine, fetchUnfulfilledDirectoryOver20Hours, fetchCatchAll, fetchAdsWithPdfConversionFailure, fetchAdsWithoutPdfs]);

  useEffect(() => {
    setInitialState();
  }, [setInitialState]);

  const onClick = () => {
    fetchAdsNoStateMachine(filters());
    fetchUnfulfilledAdsOver20Hours(filters());
    fetchDirectoryNoStateMachine(filters());
    fetchUnfulfilledDirectoryOver20Hours(filters());
    fetchAdsWithPdfConversionFailure(filters());
    fetchCatchAll(filters());
    fetchAdsWithoutPdfs(filters());
  };

  const filters = () => ({ startDate, endDate });

  const extra = () => (
    <Space direction="horizontal">
      <DatePicker.RangePicker
        allowClear={false}
        onCalendarChange={onCalendarChange}
        value={[startDate, endDate]}
      />
      <Button type="primary" onClick={onClick}>
        Filter
      </Button>
      <Button onClick={setInitialState}>Clear</Button>
    </Space>
  );

   const useExtra = (loading: boolean, records: Array<any>) => {
    if (loading) return <Spin />;
    return (
      <Fragment>
        <Tag color="geekblue">{`${records.length} Result(s)`}</Tag>
      </Fragment>
    );
  };


  return (
    <Card title="Ads Past SLA" extra={extra()}>
      <div className="accordion-container">
        <Collapse defaultActiveKey={["1", "2", "3", "4", "5", "6", "7"]}>
          <Collapse.Panel
            header="Origami ads without state machines"
            key="1"
            extra={useExtra(origamiAdsNoSmLoading, origamiAdsNoSmRecords)}
          >
            <OrigamiAdsNoSMTable loading={origamiAdsNoSmLoading} records={origamiAdsNoSmRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Unfulfilled Origami Ads over 20 hours old"
            key="2"
            extra={useExtra(unfulfilledAdsOver20HoursLoading, unfulfilledAdsOver20HoursRecords)}
          >
            <UnfulfilledAdsOver20HoursTable loading={unfulfilledAdsOver20HoursLoading} records={unfulfilledAdsOver20HoursRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Directory ads without state machines"
            key="3"
            extra={useExtra(directoryNoStateMachineLoading, directoryNoStateMachineRecords)}
          >
            <DirectoryNoStateMachineTable loading={directoryNoStateMachineLoading} records={directoryNoStateMachineRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Unfulfilled Directory Ads over 20 hours old"
            key="4"
            extra={useExtra(unfulfilledDirectoryOver20HoursLoading, unfulfilledDirectoryOver20HoursRecords)}
          >
            <UnfulfilledDirectoryOver20HoursTable loading={unfulfilledDirectoryOver20HoursLoading} records={unfulfilledDirectoryOver20HoursRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Catch All"
            key="5"
            extra={useExtra(catchAllLoading, catchAllRecords)}
          >
            <CatchAllTable loading={catchAllLoading} records={catchAllRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Ads with pdf conversion failure"
            key="6"
            extra={useExtra(adsWithPdfNoConversionLoading, adsWithPdfNoConversionRecords)}
          >
            <AdsWithPdfConversionFailureTable loading={adsWithPdfNoConversionLoading} records={adsWithPdfNoConversionRecords}/>
          </Collapse.Panel>

          <Collapse.Panel
            header="Ads without pdfs"
            key="7"
            extra={useExtra(adsWithoutPdfsLoading, adsWithoutPdfsRecords)}
          >
            <AdsWithoutPdfs loading={adsWithoutPdfsLoading} records={adsWithoutPdfsRecords}/>
          </Collapse.Panel>

        </Collapse>
      </div>
    </Card>
  );
};

const mapDispatchToProps = {
  fetchCatchAll,
  fetchAdsNoStateMachine,
  fetchUnfulfilledAdsOver20Hours,
  fetchDirectoryNoStateMachine,
  fetchUnfulfilledDirectoryOver20Hours,
  fetchAdsWithPdfConversionFailure,
  fetchAdsWithoutPdfs,
};

const mapStateToProps = ({
  reports: {
    origami_ads_without_state_machine: { loading: origamiAdsNoSmLoading, records: origamiAdsNoSmRecords },
    unfulfilled_ads_over_20_hours: { loading: unfulfilledAdsOver20HoursLoading, records: unfulfilledAdsOver20HoursRecords },
    directory_ads_without_state_machine: { loading: directoryNoStateMachineLoading, records: directoryNoStateMachineRecords },
    unfulfilled_directory_over_20_hours: { loading: unfulfilledDirectoryOver20HoursLoading, records: unfulfilledDirectoryOver20HoursRecords },
    catch_all: { loading: catchAllLoading, records: catchAllRecords },
    ads_with_pdf_conversion_failure: { loading: adsWithPdfNoConversionLoading, records: adsWithPdfNoConversionRecords },
    ads_without_pdfs: { loading: adsWithoutPdfsLoading, records: adsWithoutPdfsRecords }
  },
}: StoreType) => ({
  origamiAdsNoSmLoading,
  unfulfilledAdsOver20HoursLoading,
  origamiAdsNoSmRecords,
  unfulfilledAdsOver20HoursRecords,
  directoryNoStateMachineLoading,
  directoryNoStateMachineRecords,
  unfulfilledDirectoryOver20HoursLoading,
  unfulfilledDirectoryOver20HoursRecords,
  catchAllLoading,
  catchAllRecords,
  adsWithPdfNoConversionLoading,
  adsWithPdfNoConversionRecords,
  adsWithoutPdfsLoading,
  adsWithoutPdfsRecords,
});

AdsPastSla.propTypes = {
  fetchAdsNoStateMachine: PropTypes.func.isRequired,
  fetchUnfulfilledAdsOver20Hours: PropTypes.func.isRequired,
  fetchDirectoryNoStateMachine: PropTypes.func.isRequired,
  fetchUnfulfilledDirectoryOver20Hours: PropTypes.func.isRequired,
  fetchCatchAll: PropTypes.func.isRequired,
  fetchAdsWithPdfConversionFailure: PropTypes.func.isRequired,
  fetchAdsWithoutPdfs: PropTypes.func.isRequired,
  origamiAdsNoSmLoading: PropTypes.bool.isRequired,
  origamiAdsNoSmRecords: PropTypes.array.isRequired,
  unfulfilledAdsOver20HoursLoading: PropTypes.bool.isRequired,
  directoryNoStateMachineLoading: PropTypes.bool.isRequired,
  unfulfilledAdsOver20HoursRecords: PropTypes.array.isRequired,
  directoryNoStateMachineRecords: PropTypes.array.isRequired,
  unfulfilledDirectoryOver20HoursLoading: PropTypes.bool.isRequired,
  unfulfilledDirectoryOver20HoursRecords: PropTypes.array.isRequired,
  catchAllLoading: PropTypes.bool.isRequired,
  catchAllRecords: PropTypes.array.isRequired,
  adsWithPdfNoConversionLoading: PropTypes.bool.isRequired,
  adsWithPdfNoConversionRecords: PropTypes.array.isRequired,
  adsWithoutPdfsLoading: PropTypes.bool.isRequired,
  adsWithoutPdfsRecords: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdsPastSla);